import * as React from 'react';
import Icon from '../Icon';


var InvestmentIcon = function (_a) {
    var className = _a.className, onClick = _a.onClick;
    return (React.createElement(Icon, { width: "32", height: "33", viewBox: "0 0 32 33", fill: "none", className: "InvestmentIcon " + (className || ''), onClick: onClick },
        React.createElement("path", { d: "M0 2C0 0.895431 0.895431 0 2 0H29.4286C30.5332 0 31.4286 0.895431 31.4286 2V30.6344C31.4286 31.739 30.5332 32.6344 29.4286 32.6344H2C0.89543 32.6344 0 31.739 0 30.6344V2Z", fill: "#EBE8F1" }),
        React.createElement("path", { d: "M11.7143 21.9716V26.6344M7.14264 25.4286V26.6032M16.2856 18V26.6122M20.857 13.4065V26.6216M25.4286 8.8404V26.6191M6 21.4286L21.4286 6L15.4286 6", stroke: "#271158", strokeWidth: "2", strokeLinecap: "round" })));
};
export default React.memo(InvestmentIcon);
